module.exports = __webpack_public_path__ + "static/img/bg-pt.1c537752.png";